import React, { type PropsWithChildren } from 'react';
import './Dialog.css';

interface IProps {
  readonly isOpened: boolean;
  readonly onSubmit: () => void;
  readonly onCancel: () => void;
  readonly onReset: () => void;
}

const Dialog: React.FC<PropsWithChildren<IProps>> = ({ children, onReset, onCancel, onSubmit, isOpened }) => {
  if (!isOpened) {
    return null;
  }

  return (
    <div data-group="scolab-switcher" id="scolab-switcher-dialog">
      <div className="scolab-switcher-dialog-content">
        {children}
      </div>
      <div className="scolab-switcher-dialog-footer">
        <button type="button" className="scolab-switcher-button" onClick={() => onReset()}>Reset</button>
        <button type="button" className="scolab-switcher-button" onClick={() => onCancel()}>Cancel</button>
        <button type="button" className="scolab-switcher-button scolab-switcher-button-primary"
          onClick={() => onSubmit()}>Apply
        </button>
      </div>
    </div>
  );
};

export default Dialog;